/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Icsrm_Icsrm10Inputs */

const en_cv_extract_form_enum_icsrm_icsrm10 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Icsrm10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TU Darmstadt`)
};

const de_cv_extract_form_enum_icsrm_icsrm10 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Icsrm10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TU Darmstadt`)
};

/**
* | output |
* | --- |
* | "TU Darmstadt" |
*
* @param {Cv_Extract_Form_Enum_Icsrm_Icsrm10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_icsrm_icsrm10 = /** @type {((inputs?: Cv_Extract_Form_Enum_Icsrm_Icsrm10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Icsrm_Icsrm10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_icsrm_icsrm10(inputs)
	return en_cv_extract_form_enum_icsrm_icsrm10(inputs)
});
export { cv_extract_form_enum_icsrm_icsrm10 as "cv_extract_form_enum_ICSRM_ICSRM" }